export const COUNTRY = 'country'
export const COUNTRYSWITCH_ACTION_STAY = 'countryswitch-action-stay'
export const LAST_VISITED_LOCALE = 'lastVisitedLocale'
export const LAST_SITE_ID = 'lastSiteId'
